/**
 * Navigation menu data
 *
 * @type {Array of Objects}
 * @param {string} color Left icon color for different menu
 * @param {string} action Left icon of the list
 * @param {string} title Title of the list
 * @param {string} linkTo Router path
 * @param {array} items.items Child list items
 *
 */

const items = [
  {
    color: '#333',
    action: 'explore',
    title: 'Dashboard',
    linkTo: '/dashboard'
  },
  {
    color: '#333',
    action: 'desktop_mac',
    title: 'Product View',
    linkTo: '/product-view'
  },
  {
    color: '#333',
    action: 'timeline',
    title: 'Analytics',
    linkTo: '/analytics'
  },
  {
    color: '#333',
    action: 'notifications',
    title: 'My alerts',
    linkTo: '/alerts'
  },
  {
    color: '#333',
    action: 'map',
    title: 'Availability Mapping',
    linkTo: '/availability-mapping'
  },
  {
    color: '#333',
    action: 'file_copy',
    title: 'Reports Settings',
    linkTo: '/reports-settings'
  }
  // ,
  // {
  //   color: '#333',
  //   action: 'group',
  //   title: 'Users',
  //   linkTo: '/users'
  // }
]
export default items



// WEBPACK FOOTER //
// ./src/components/sidebar/navData.js